import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { createContext, useContext } from 'react';
import { CardSliderModule, TextModule } from '..';
import css from './index.module.scss';
const CARD_MODULE_TYPES = createContext({
    TEXT_LIST: 'textList' || 1,
    TEXT_IMAGE: 'textImage' || 2,
    TEXT_IMAGE_SLIDE: 'textImageSlide' || 3,
    TEXT_TEXT_LEFT: 'textTextLeft' || 4,
    TEXT_TEXT_RIGHT: 'textTextRight' || 5,
});

const defaultStyle = {
    backColor: '#fff',
    height: 'auto',
    guideStyle: {},
    titleStyle: {},
    descStyle: {},
    sliderConfig: {},
};

const defaultData = {
    type: 'textList', // textList, textImage, textImageSlide, textTextLeft, textTextRight
    textGuide: 'Interior / Exterior Design',
    textTitle: 'Power pretty much anything ',
    textDesc:
        'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
    items: [
        {
            title: 'Power your home for days',
            desc: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            url: '/img/card-battery-1.png',
        },
        {
            title: 'Power your home for days',
            desc: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            url: '/img/card-battery-2.png',
        },
    ],
    singleImg: '/img/card-microapp.png',
    textTextTitleLeft: 'The world’s fastest wall charge. ',
    textTextTitleRight: 'EV station charging. That’s a world first.',
    textTextDescLeft: 'And of course, you can plug in at home to charge while the grid is online. Get a full charge in as fast as 1.8 hours.',
    textTextDescRight: 'Charge up at thousands of AC level 2 EV stations worldwide to get up to 3400W of input. Enough to charge to full in 1.7 hours.',
};

export default function CardModule({ cssStyle, data }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { backColor, height, guideStyle, titleStyle, descStyle, sliderConfig, webpUrl } = styles;
    const { EFPic } = createEFPic(webpUrl || '/');
    const dataObj = {
        type: data?.type ?? defaultData.type,
        textGuide: data?.textGuide ?? defaultData.textGuide,
        textTitle: data?.textTitle ?? defaultData.textTitle,
        textDesc: data?.textDesc ?? defaultData.textDesc,
        items: data?.items ?? defaultData.items,
        singleImg: data?.singleImg ?? defaultData.singleImg,
        textTextTitleLeft: data?.textTextTitleLeft ?? defaultData.textTextTitleLeft,
        textTextTitleRight: data?.textTextTitleRight ?? defaultData.textTextTitleRight,
        textTextDescLeft: data?.textTextDescLeft ?? defaultData.textTextDescLeft,
        textTextDescRight: data?.textTextDescRight ?? defaultData.textTextDescRight,
    };
    const cardTypes = useContext(CARD_MODULE_TYPES);
    const { type, textGuide, textTitle, textDesc, items, singleImg, textTextTitleLeft, textTextTitleRight, textTextDescLeft, textTextDescRight } = dataObj;
    const { useLang } = useGlobal();
    const { t } = useLang('product');
    const isWhiteTheme = backColor === '#fff' || backColor === '#ffffff' || backColor === 'white' || backColor === 'transparent';

    const convertData = (data: any) => {
        const result: any = [];
        data.forEach((item: any) => {
            result.push({ img: item.url, desc: item.title });
        });
        return result;
    };

    return (
        <div
            className={isWhiteTheme ? `${css.cardModule} cardModule` : `${css.cardModule} cardModule cardModuleBlackTheme`}
            style={{ background: backColor, height: height }}
        >
            {/* 1. textList: 上文本，下图片列表（列表上部带文字） */}
            {type === cardTypes.TEXT_LIST && (
                <div className="container textListContainer">
                    <TextModule
                        cssStyle={{
                            ...{
                                fontClass: 'font-family-semibold',
                                fontWeight: 500,
                                theme: isWhiteTheme ? 'white' : 'black',
                                textAlign: 'center',
                                fontSize: '32px',
                                lineHeight: '40px',
                                color: isWhiteTheme ? '#000' : '#ededed',
                            },
                            ...guideStyle,
                        }}
                        data={{ text: textGuide }}
                    />
                    <TextModule
                        cssStyle={{
                            ...{
                                type: 'ls',
                                textAlign: 'center',
                                theme: isWhiteTheme ? 'white' : 'black',
                                color: isWhiteTheme ? '#03060b' : '#ffffff',
                                margin: textTitle ? '10px auto 40px auto' : '0 auto',
                            },
                            ...titleStyle,
                        }}
                        data={{ text: textTitle }}
                    />
                    <TextModule
                        cssStyle={{
                            ...{
                                type: 'sl',
                                textAlign: 'center',
                                theme: isWhiteTheme ? 'white' : 'black',
                                fontFamily: 'var(--font-family-Medium)',
                                fontWeight: isWhiteTheme ? 600 : 500,
                                color: isWhiteTheme ? '#666666' : '#999999',
                                margin: textDesc ? '0 auto 90px auto' : '0 auto',
                            },
                            ...descStyle,
                        }}
                        data={{ text: textDesc }}
                    />
                    <div className="listBox">
                        {items.map((item: any, k: number) => (
                            <li
                                className="list"
                                key={k}
                                style={{
                                    marginLeft: k === 0 ? 0 : '40px',
                                    background: isWhiteTheme ? '#fff' : '#000',
                                }}
                            >
                                {Array.isArray(item?.url) ? (
                                    <EFPic name={item.url} alt={t(item.alt)} />
                                ) : (
                                    <Image src={item.url} width={500} height={640} alt={t(item.alt)} />
                                )}
                                <div className="floatText">
                                    <p
                                        className="listText listTextTitle font-family-semibold"
                                        style={{
                                            color: isWhiteTheme ? '#03060b' : '#fff',
                                            margin: '0 auto',
                                            maxWidth: '380px',
                                        }}
                                    >
                                        {item.title}
                                    </p>
                                    <p
                                        className="listText listTextDesc"
                                        style={
                                            isWhiteTheme
                                                ? { margin: '14px auto 0 auto', maxWidth: '380px' }
                                                : {
                                                      margin: '14px auto 0 auto',
                                                      color: '#919191',
                                                      maxWidth: '380px',
                                                  }
                                        }
                                        dangerouslySetInnerHTML={{ __html: item.desc }}
                                    ></p>
                                </div>
                            </li>
                        ))}
                    </div>
                </div>
            )}
            {/* 2. textImage: 上文本，下大图排列 */}
            {type === cardTypes.TEXT_IMAGE && (
                <div className="textImageContainer">
                    <div className="container">
                        <TextModule
                            cssStyle={{
                                ...{
                                    fontClass: 'font-family-semibold',
                                    fontWeight: 500,
                                    theme: isWhiteTheme ? 'white' : 'black',
                                    fontSize: '32px',
                                    margin: '0 auto',
                                    lineHeight: '40px',
                                    color: isWhiteTheme ? '#000' : '#ededed',
                                    textAlign: 'center',
                                    width: '924px',
                                },
                                ...guideStyle,
                            }}
                            data={{ text: textGuide }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'ls',
                                    theme: isWhiteTheme ? 'white' : 'black',
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#03060b' : '#ffffff',
                                    margin: textTitle ? '10px auto 40px auto' : '0 auto',
                                },
                                ...titleStyle,
                            }}
                            data={{ text: textTitle }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'sl',
                                    fontFamily: 'var(--font-family-Medium)',
                                    theme: isWhiteTheme ? 'white' : 'black',
                                    fontWeight: isWhiteTheme ? 600 : 500,
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#666666' : '#999999',
                                    margin: textDesc ? '0 auto 90px auto' : '0 auto',
                                },
                                ...descStyle,
                            }}
                            data={{ text: textDesc }}
                        />
                    </div>
                    <div className="listBox">
                        {items.map((item: any, k: number) => (
                            <li className="list" key={k} style={{ marginLeft: k === 0 ? 0 : '20px' }}>
                                {Array.isArray(item?.url) ? (
                                    <EFPic name={item.url} alt={t(item.alt)} />
                                ) : (
                                    <Image src={item.url} width={950} height={540} alt={t(item.alt)} />
                                )}
                                <span className={k === 0 ? 'label labelRight font-family-extrabold' : 'label font-family-extrabold'}>{item.guide}</span>
                            </li>
                        ))}
                    </div>
                </div>
            )}
            {/* 3. textImageSlide: 上文本，下可滑动图片 */}
            {type === cardTypes.TEXT_IMAGE_SLIDE && (
                <div className={`${css.textImageSlide} textImageSlide`}>
                    <div className="container">
                        <TextModule
                            cssStyle={{
                                ...{
                                    fontClass: 'font-family-semibold',
                                    fontWeight: 500,
                                    theme: isWhiteTheme ? 'white' : 'black',
                                    fontSize: '32px',
                                    lineHeight: '40px',
                                    margin: '0 auto',
                                    color: isWhiteTheme ? '#000' : '#ededed',
                                    textAlign: 'center',
                                    width: '924px',
                                },
                                ...guideStyle,
                            }}
                            data={{ text: textGuide }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'ls',
                                    theme: isWhiteTheme ? 'white' : 'black',
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#03060b' : '#ffffff',
                                    margin: textTitle ? '10px auto 40px auto' : '0 auto',
                                },
                                ...titleStyle,
                            }}
                            data={{ text: textTitle }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'sl',
                                    fontFamily: 'var(--font-family-Medium)',
                                    theme: isWhiteTheme ? 'white' : 'black',
                                    fontWeight: isWhiteTheme ? 600 : 500,
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#666666' : '#999999',
                                    margin: textDesc ? '0 auto 90px auto' : '0 auto',
                                },
                                ...descStyle,
                            }}
                            data={{ text: textDesc }}
                        />
                    </div>
                    <CardSliderModule data={convertData(items)} cssStyle={{ ...sliderConfig, ...{ theme: isWhiteTheme ? '#fff' : '#000' }, webpUrl }} />
                </div>
            )}
            {/* 4. textTextLeft: 左侧纯文字卡片，右侧图片上覆盖文字卡片 */}
            {type === cardTypes.TEXT_TEXT_LEFT && (
                <div className="container textTextLeftContainer" style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
                    <div className="left" style={{ background: isWhiteTheme ? '#f6f6f8' : '#181818' }}>
                        <TextModule
                            data={{ text: textTextTitleLeft }}
                            cssStyle={{
                                type: 'ls',
                                backColor: 'transparent',
                                fontSize: '52px',
                                lineHeight: '56px',
                                textAlign: 'cener',
                                margin: textTextTitleLeft ? '70px 0 0 70px' : '0 auto',
                                width: '300px',
                                color: isWhiteTheme ? '#03060b' : '#ffffff',
                            }}
                        />
                        <TextModule
                            data={{ text: textTextDescLeft }}
                            cssStyle={{
                                type: 'sm',
                                backColor: 'transparent',
                                fontFamily: 'var(--font-family-SemiBold)',
                                fontWeight: isWhiteTheme ? 500 : 400,
                                margin: textTextDescLeft ? '40px 0 0 70px' : '0 auuto',
                                textAlign: 'cener',
                                width: '300px',
                                color: isWhiteTheme ? '#666666' : '#919191',
                            }}
                        />
                    </div>
                    <div className="right">
                        {Array.isArray(singleImg) ? (
                            <EFPic name={singleImg} alt={t(textTextTitleLeft)} />
                        ) : (
                            <Image src={singleImg} width={630} height={526} alt={t(textTextTitleLeft)} />
                        )}
                        <div className="imgText">
                            <TextModule
                                data={{ text: textTextTitleRight }}
                                cssStyle={{
                                    type: 'ls',
                                    backColor: 'transparent',
                                    fontSize: '52px',
                                    lineHeight: '56px',
                                    textAlign: 'cener',
                                    margin: textTextTitleRight ? '0 0 40px' : '0 auto',
                                    width: '350px',
                                    color: isWhiteTheme ? '#03060b' : '#ffffff',
                                }}
                            />
                            <TextModule
                                data={{ text: textTextDescRight }}
                                cssStyle={{
                                    type: 'sm',
                                    backColor: 'transparent',
                                    fontFamily: 'var(--font-family-SemiBold)',
                                    fontWeight: isWhiteTheme ? 500 : 400,
                                    textAlign: 'cener',
                                    width: '350px',
                                    color: isWhiteTheme ? '#666666' : '#919191',
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            {/* 5. textTextRight: 右侧纯文字卡片，左侧图片上覆盖文字卡片 */}
            {type === cardTypes.TEXT_TEXT_RIGHT && (
                <div className="container textTextRightContainer" style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
                    <div className="left">
                        {Array.isArray(singleImg) ? (
                            <EFPic name={singleImg} alt={t(textTextTitleRight)} />
                        ) : (
                            <Image src={singleImg} width={630} height={526} alt={t(textTextTitleRight)} />
                        )}
                        <div className="imgText">
                            <TextModule
                                data={{ text: textTextTitleRight }}
                                cssStyle={{
                                    type: 'ls',
                                    backColor: 'transparent',
                                    fontSize: '52px',
                                    lineHeight: '56px',
                                    textAlign: 'cener',
                                    margin: textTextTitleRight ? '0 0 40px' : '0 auto',
                                    width: '350px',
                                    color: isWhiteTheme ? '#03060b' : '#ffffff',
                                }}
                            />
                            <TextModule
                                data={{ text: textTextDescRight }}
                                cssStyle={{
                                    type: 'sm',
                                    backColor: 'transparent',
                                    fontFamily: 'var(--font-family-SemiBold)',
                                    fontWeight: isWhiteTheme ? 500 : 400,
                                    textAlign: 'cener',
                                    width: '350px',
                                    color: isWhiteTheme ? '#666666' : '#919191',
                                }}
                            />
                        </div>
                    </div>
                    <div className="right" style={{ background: isWhiteTheme ? '#f6f6f8' : '#181818' }}>
                        <TextModule
                            data={{ text: textTextTitleLeft }}
                            cssStyle={{
                                type: 'ls',
                                backColor: 'transparent',
                                fontFamily: 'var(--font-family-ExtraBold)',
                                fontWeight: 700,
                                fontSize: '52px',
                                lineHeight: '56px',
                                textAlign: 'cener',
                                margin: textTextTitleRight ? '70px 0 0 70px' : '0 auto',
                                width: '300px',
                                color: isWhiteTheme ? '#03060b' : '#ffffff',
                            }}
                        />
                        <TextModule
                            data={{ text: textTextDescLeft }}
                            cssStyle={{
                                type: 'sm',
                                backColor: 'transparent',
                                fontFamily: 'var(--font-family-SemiBold)',
                                fontWeight: isWhiteTheme ? 500 : 400,
                                margin: textTextDescRight ? '40px 0 0 70px' : '0 auto',
                                textAlign: 'cener',
                                width: '300px',
                                color: isWhiteTheme ? '#666666' : '#919191',
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
